
export default {
  props: ["section"],
  provide() {
    return {
      getSection: () => {
        return this.section;
      }
    }
  },
  data() {
    return {

    };
  },
  computed: {
    sectionData: {
      get() {
        return this.section;
      },
      set(value) {

      }
    }
  },
  mounted() {
    //this.$wow.sync();
  }, 
  methods: {

  }
};
